// Global namespace for collection functionality
window.CollectionJS = window.CollectionJS || {};

(function() {
  function setQuickAddState(card, isAvailable) {
    var quickAdd = card.querySelector('.collection-product__quick-add');
    if (!quickAdd) return;

    var tip = quickAdd.querySelector('.collection-product__quick-add-tooltip');

    if (isAvailable) {
      quickAdd.classList.remove('is-sold-out');
      quickAdd.removeAttribute('aria-disabled');
      quickAdd.removeAttribute('tabindex');

      var badge = quickAdd.querySelector('.quick-add-plus');
      if (badge) badge.textContent = '+';

      if (tip) tip.hidden = false;
    } else {
      quickAdd.classList.add('is-sold-out');
      quickAdd.setAttribute('aria-disabled', 'true');
      quickAdd.setAttribute('tabindex', '-1');

      var badge2 = quickAdd.querySelector('.quick-add-plus');
      if (badge2) badge2.textContent = 'x';

      if (tip) tip.hidden = true;
    }
  }

  function getHandleFromProductUrl(url) {
    if (!url) return '';
    var parts = url.split('/products/');
    if (parts.length < 2) return '';
    var handle = parts[1];
    if (!handle) return '';
    return handle.split('?')[0].split('#')[0];
  }

  /* ----------------------------------------
   * Preload swatch images for a card into browser cache
   * ---------------------------------------- */
  function preloadSwatchImages(card) {
    if (card.hasAttribute('data-swatches-preloaded')) return;
    card.setAttribute('data-swatches-preloaded', 'true');
    var buttons = card.querySelectorAll('.collection-product__swatch-button');
    buttons.forEach(function (btn) {
      var src = btn.getAttribute('data-variant-image');
      if (src) {
        var img = new Image();
        img.src = src;
      }
    });
  }

  /* ----------------------------------------
   * Initialize card interactions
   * Can be called multiple times for new products
   * ---------------------------------------- */
  function initializeProductCards(container) {
    var cards = container ? container.querySelectorAll('.collection-product') : document.querySelectorAll('.collection-product');

    cards.forEach(function (card) {
      // Skip if already initialized
      if (card.hasAttribute('data-collection-initialized')) return;
      card.setAttribute('data-collection-initialized', 'true');
    var frame = card.querySelector('.collection-product__media');
    var primaryImg = card.querySelector('.js-collection-image');
    var swatchButtons = card.querySelectorAll('.collection-product__swatch-button');
    var quickAdd = card.querySelector('.collection-product__quick-add');

    // Default variant id (first variant)
    var defaultVariantId = card.getAttribute('data-default-variant-id');

    // Default image src
    var defaultSrc = null;
    if (primaryImg) {
      defaultSrc = primaryImg.getAttribute('data-default-image') || primaryImg.getAttribute('src');
    }

    /* ----------------------------------------
     * Disable OOS swatches (based on data-variant-available)
     * + Set default active swatch (first available)
     * ---------------------------------------- */
    var defaultActiveBtn = null;

    // Swatch hover + click
    swatchButtons.forEach(function (btn) {
      var availableAttr = btn.getAttribute('data-variant-available');
      var isAvailable = availableAttr === 'true';

      if (!isAvailable) {
        btn.classList.add('is-disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('tabindex', '-1');
      } else {
        btn.classList.remove('is-disabled');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('tabindex');

        // pick first available as default active
        if (!defaultActiveBtn) defaultActiveBtn = btn;
      }
    });

    // Apply default active ring
    if (defaultActiveBtn) {
      defaultActiveBtn.classList.add('is-active');
    }

    // Flash only when hovering the IMAGE FRAME (and secondary image exists)
    if (frame && primaryImg) {
      var hasSecondaryImage = !!card.querySelector('.collection-product__image.is-secondary');

      // Find the secondary swatch (first non-default, non-disabled)
      var secondarySwatchBtn = null;
      for (var si = 0; si < swatchButtons.length; si++) {
        if (swatchButtons[si] !== defaultActiveBtn && !swatchButtons[si].classList.contains('is-disabled')) {
          secondarySwatchBtn = swatchButtons[si];
          break;
        }
      }

      frame.addEventListener('mouseenter', function () {
        preloadSwatchImages(card);
        if (hasSecondaryImage) {
          card.classList.add('is-flashing');
          // Previously moved the active ring to the "secondary" swatch on hover.
          // Removed: on exploded tiles this would shift the ring off the tile's
          // own colour (which is the only one that belongs here). On regular
          // tiles it was also confusing (hover image → ring jumps to a colour
          // you're not hovering).
        }
      });

      frame.addEventListener('mouseleave', function () {
        card.classList.remove('is-flashing');

        // Reset primary image
        if (defaultSrc) primaryImg.setAttribute('src', defaultSrc);

        // Reset active preview back to default (so ring persists)
        swatchButtons.forEach(function (btn) {
          btn.classList.remove('is-active');
        });
        if (defaultActiveBtn) defaultActiveBtn.classList.add('is-active');
      });
    }

    swatchButtons.forEach(function (button) {
      button.addEventListener('mouseenter', function () {
        // If disabled, do nothing
        if (button.classList.contains('is-disabled')) return;
        if (!primaryImg) return;
        // Locked-away swatches on exploded tiles have no data-color-name;
        // skip hover effects for them (click-only, keeps the tile's own ring active).
        if (!button.getAttribute('data-color-name')) return;

        var variantImg = button.getAttribute('data-variant-image');

        if (variantImg) {
          primaryImg.setAttribute('src', variantImg);
        } else if (defaultSrc) {
          primaryImg.setAttribute('src', defaultSrc);
        }

        swatchButtons.forEach(function (btn) {
          btn.classList.remove('is-active');
        });
        button.classList.add('is-active');

        card.classList.remove('is-flashing');

        // Sync size overlay with hovered swatch colour
        var swatchColor = button.getAttribute('data-color-name') || '';
        if (swatchColor && card._sizeOverlayUpdate) {
          card._sizeOverlayUpdate(swatchColor);
        }
      });

      // Click swatch -> go to variant URL
      button.addEventListener('click', function () {
        if (button.classList.contains('is-disabled')) return;

        var variantUrl = button.getAttribute('data-variant-url');
        if (variantUrl) {
          window.location.href = variantUrl;
          return;
        }

        var productUrl = card.getAttribute('data-product-url');
        if (productUrl) window.location.href = productUrl;
      });
    });

    // ── Size overlay logic ──
    var sizeOverlay = card.querySelector('.collection-product__size-overlay');
    if (sizeOverlay) {
      var overlayDataEl = card.querySelector('[data-size-overlay-data]');
      var overlayData = null;
      if (overlayDataEl) {
        try { overlayData = JSON.parse(overlayDataEl.textContent); } catch (e) {}
      }

      var sizePills = sizeOverlay.querySelectorAll('.size-pill');
      var productUrl = card.getAttribute('data-product-url') || '';
      var colourLabel = sizeOverlay.querySelector('[data-overlay-colour-label]');
      var prevArrow = sizeOverlay.querySelector('.size-overlay__arrow--prev');
      var nextArrow = sizeOverlay.querySelector('.size-overlay__arrow--next');

      // Build ordered list of available colour names from card swatches
      var overlayColours = [];
      swatchButtons.forEach(function (btn) {
        if (!btn.classList.contains('is-disabled')) {
          var name = btn.getAttribute('data-color-name') || '';
          var img = btn.getAttribute('data-variant-image') || '';
          if (name) overlayColours.push({ name: name, image: img });
        }
      });

      var defaultColorName = defaultActiveBtn ? (defaultActiveBtn.getAttribute('data-color-name') || '') : '';
      var overlayColorIndex = 0;

      // Find the secondary colour index (shown on image hover swap)
      var secondaryIndex = 0;
      if (overlayColours.length > 1) {
        for (var si = 0; si < overlayColours.length; si++) {
          if (overlayColours[si].name !== defaultColorName) {
            secondaryIndex = si;
            break;
          }
        }
      }

      function updateSizePills(colorName) {
        if (!overlayData || !colorName) return;
        var colorData = overlayData[colorName];
        if (!colorData) return;

        sizePills.forEach(function (pill) {
          var sizeVal = pill.getAttribute('data-size-value');
          var info = colorData[sizeVal];
          if (info) {
            pill.classList.toggle('size-pill--oos', !info.available);
            if (info.variantId) {
              pill.href = productUrl + '?variant=' + info.variantId;
            }
          }
        });
      }

      function setOverlayColour(index) {
        if (!overlayColours.length) return;
        overlayColorIndex = ((index % overlayColours.length) + overlayColours.length) % overlayColours.length;
        var colour = overlayColours[overlayColorIndex];
        if (colourLabel) colourLabel.textContent = colour.name;
        updateSizePills(colour.name);

        // Swap image to match
        if (primaryImg && colour.image) {
          primaryImg.setAttribute('src', colour.image);
          // Stop the CSS flash since we're manually setting the image
          card.classList.remove('is-flashing');
        }

        // Sync card swatch active ring to match
        swatchButtons.forEach(function (btn) {
          btn.classList.toggle('is-active', btn.getAttribute('data-color-name') === colour.name);
        });
      }

      // Arrow clicks
      if (prevArrow) {
        prevArrow.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setOverlayColour(overlayColorIndex - 1);
        });
      }
      if (nextArrow) {
        nextArrow.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setOverlayColour(overlayColorIndex + 1);
        });
      }

      if (frame) {
        // Removed: old mouseenter that auto-cycled colour on hover and reset
        // is-flashing. Arrow clicks still switch colours via setOverlayColour.

        frame.addEventListener('mouseleave', function () {
          // Reset to default colour
          if (defaultColorName) {
            for (var di = 0; di < overlayColours.length; di++) {
              if (overlayColours[di].name === defaultColorName) {
                overlayColorIndex = di;
                break;
              }
            }
          }
        });
      }

      // Size pill click: stop propagation so card link doesn't fire
      sizePills.forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });

      // Expose update function so swatch hover can sync the overlay
      card._sizeOverlayUpdate = function (colorName) {
        for (var ui = 0; ui < overlayColours.length; ui++) {
          if (overlayColours[ui].name === colorName) {
            overlayColorIndex = ui;
            break;
          }
        }
        if (colourLabel) colourLabel.textContent = colorName;
        updateSizePills(colorName);
      };

      // Initialise pills for default colour
      if (!defaultColorName && overlayData) {
        var firstColor = Object.keys(overlayData)[0];
        if (firstColor) updateSizePills(firstColor);
      } else if (defaultColorName && overlayData) {
        updateSizePills(defaultColorName);
      }
    }

    // Quick add click (SINGLE source of truth)
    if (quickAdd) {
      quickAdd.addEventListener('click', function (e) {
        var isSoldOut = quickAdd.classList.contains('is-sold-out') || quickAdd.getAttribute('aria-disabled') === 'true';

        if (isSoldOut) return;

        var productUrl = card.getAttribute('data-product-url') || '';
        var handle = getHandleFromProductUrl(productUrl);

        // Liquid flag (if it exists)
        var requiresSelection = card.getAttribute('data-requires-selection') === 'true';

        // NOTE: More reliable: if there are swatches, there are variants/choices
        var hasSwatches = !!card.querySelector('.collection-product__swatches');

        // NOTE: When QuickView is available, open it for anything that looks "selectable"
        // (shoes, colours, multi-variant products)
        var canQuickView = window.QuickView && typeof window.QuickView.open === 'function';
        var shouldOpenQuickView = canQuickView && handle && (requiresSelection || hasSwatches);

        if (shouldOpenQuickView) {
          e.preventDefault();
          window.QuickView.open(handle);
          return;
        }

        // If it's a selectable product but QuickView isn't available, go to PDP
        if ((requiresSelection || hasSwatches) && productUrl) {
          // allow default navigation OR force it:
          // (forcing ensures no weird double-handlers)
          e.preventDefault();
          window.location.href = productUrl;
          return;
        }

        // Non-selectable: ajax add (if CartAPI exists), otherwise allow default navigation
        if (!(window.CartAPI && typeof window.CartAPI.addToCart === 'function')) {
          return;
        }

        e.preventDefault();

        var variantIdToAdd = defaultVariantId;
        if (!variantIdToAdd) return;

        quickAdd.setAttribute('aria-busy', 'true');

        var featuredImage = card.getAttribute('data-featured-image') || '';
        var itemPayload = { id: Number(variantIdToAdd), quantity: 1 };
        if (featuredImage) {
          itemPayload.properties = { '_featured_image': featuredImage };
        }

        window.CartAPI
          .addToCart({
            items: [itemPayload]
          })
          .catch(function () {
            var url = card.getAttribute('data-product-url');
            if (url) window.location.href = url;
          })
          .finally(function () {
            quickAdd.removeAttribute('aria-busy');
          });
      });
    }
  });

  // Swap secondary images for any newly initialized cards
  swapSecondaryImages();
  }

  /* ----------------------------------------
   * Collection filters
   * All state lives here so nothing leaks or stacks.
   * ---------------------------------------- */
  var filters = {
    debounceId: null,
    controller: null,
    requestId: 0,
    bound: false
  };

  function getForm() {
    return document.getElementById('CollectionFiltersForm');
  }

  function closeAllGroups(except) {
    var form = getForm();
    if (!form) return;
    form.querySelectorAll('details.filter-group[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  function hideDisabledOptions(form) {
    form.querySelectorAll('.filter-label.is-disabled').forEach(function (label) {
      var row = label.closest('li');
      if (row) row.hidden = true;
      else label.hidden = true;
    });
  }

  function updateRangeValue(input) {
    var wrapper = input.closest('[data-price-range]');
    if (!wrapper) return;
    var output = wrapper.querySelector('[data-price-range-max]');
    if (!output) return;
    var symbol = wrapper.getAttribute('data-currency-symbol') || '';
    var value = Number(input.value || 0);
    output.textContent = symbol + value.toLocaleString(undefined, { maximumFractionDigits: 2 });
  }

  function applyFilters(filtersOnly) {
    var form = getForm();
    if (!form) return;

    filters.requestId += 1;
    var thisRequest = filters.requestId;

    if (filters.controller) filters.controller.abort();
    filters.controller = new AbortController();

    var sidebar = document.querySelector('.collection-sidebar');
    var overlay = document.getElementById('CollectionFilterOverlay');
    var wasSidebarOpen = sidebar && sidebar.classList.contains('is-open');
    var wasOverlayOpen = overlay && overlay.classList.contains('is-open');
    var wasDrawerOpen = document.body.classList.contains('collection-drawer-open');

    // Remember which filter group is open by its title text
    var openGroupTitle = null;
    var openGroup = form.querySelector('details.filter-group[open]');
    if (openGroup) {
      var titleEl = openGroup.querySelector('.filter-group__title');
      if (titleEl) openGroupTitle = titleEl.textContent.trim();
    }

    var params = new URLSearchParams(new FormData(form));
    var url = form.action + '?' + params.toString();
    var scrollY = window.scrollY;

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: filters.controller.signal
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Filter request failed');
        return r.text();
      })
      .then(function (html) {
        if (thisRequest !== filters.requestId) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Update filter form contents
        var newForm = doc.getElementById('CollectionFiltersForm');
        if (newForm) form.innerHTML = newForm.innerHTML;

        // Close all groups that the server sent back as open
        // (Shopify adds open to groups with active values)
        // We'll restore only the one the user was interacting with below.
        form.querySelectorAll('details.filter-group[open]').forEach(function (d) {
          d.removeAttribute('open');
        });

        // Only update products/title/URL when user changes filters (not on initial load)
        if (!filtersOnly) {
          // Update products
          var products = document.querySelector('.collection-products');
          var newProducts = doc.querySelector('.collection-products');
          if (products && newProducts) products.innerHTML = newProducts.innerHTML;

          // Update title
          var title = document.querySelector('.collection-header .collection-title');
          var newTitle = doc.querySelector('.collection-header .collection-title');
          if (title && newTitle) title.innerHTML = newTitle.innerHTML;

          // Update mobile controls (shows/hides external Clear link)
          var mobileControls = document.querySelector('.collection-mobile-controls');
          var newMobileControls = doc.querySelector('.collection-mobile-controls');
          if (mobileControls && newMobileControls) {
            mobileControls.innerHTML = newMobileControls.innerHTML;
            // Re-bind toggle since innerHTML destroyed the old listener
            var newToggle = document.getElementById('MobileFilterToggle');
            if (newToggle) {
              newToggle.addEventListener('click', function() {
                var sb = document.querySelector('.collection-sidebar');
                var ov = document.getElementById('CollectionFilterOverlay');
                if (sb) sb.classList.toggle('is-open');
                if (ov) ov.classList.toggle('is-open');
                if (newToggle) newToggle.classList.toggle('is-active');
                document.body.classList.toggle('collection-drawer-open');
              });
            }
          }

          // Restore sidebar/overlay/body state (drawer is always used now)
          var sidebarAfter = document.querySelector('.collection-sidebar');
          var overlayAfter = document.getElementById('CollectionFilterOverlay');
          if (wasSidebarOpen && sidebarAfter) sidebarAfter.classList.add('is-open');
          if (wasOverlayOpen && overlayAfter) overlayAfter.classList.add('is-open');
          if (wasDrawerOpen) document.body.classList.add('collection-drawer-open');

          window.history.pushState({}, '', url);

          // Restore scroll only when drawer is closed (user is browsing products)
          if (!wasSidebarOpen) {
            window.scrollTo(0, scrollY);
          }

          // Re-init product cards
          initializeProductCards(products);

          // Dispatch event so infinite scroll can re-check pagination state
          document.dispatchEvent(new CustomEvent('collection:filtered'));
        }

        // Re-run post-render setup (price inputs, hide disabled)
        setupFormContent();

        // Restore the open filter group
        if (openGroupTitle) {
          var groups = form.querySelectorAll('details.filter-group');
          for (var i = 0; i < groups.length; i++) {
            var t = groups[i].querySelector('.filter-group__title');
            if (t && t.textContent.trim() === openGroupTitle) {
              groups[i].setAttribute('open', '');
              break;
            }
          }
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (!filtersOnly) window.location.href = url;
      });
  }

  function closeDrawer() {
    var sb = document.querySelector('.collection-sidebar');
    var ov = document.getElementById('CollectionFilterOverlay');
    var tg = document.getElementById('MobileFilterToggle');
    if (sb) sb.classList.remove('is-open');
    if (ov) ov.classList.remove('is-open');
    if (tg) tg.classList.remove('is-active');
    document.body.classList.remove('collection-drawer-open');
  }

  // Run after form innerHTML is replaced — sets up price inputs & hides disabled
  function setupFormContent() {
    var form = getForm();
    if (!form) return;

    form.querySelectorAll('.filter-price-range__input').forEach(function (input) {
      updateRangeValue(input);
    });

    hideDisabledOptions(form);

    // Hide entire filter groups where every option is hidden/disabled
    form.querySelectorAll('details.filter-group').forEach(function (group) {
      var items = group.querySelectorAll('.filter-list li');
      if (!items.length) { group.hidden = true; return; }
      var allHidden = true;
      for (var i = 0; i < items.length; i++) {
        if (!items[i].hidden) { allHidden = false; break; }
      }
      group.hidden = allHidden;
    });
  }

  function initializeFilters() {
    var form = getForm();
    if (!form) return;

    // Only bind listeners once — they use event delegation
    // so they survive innerHTML replacements
    if (filters.bound) {
      setupFormContent();
      return;
    }
    filters.bound = true;

    // Prevent default form submission
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      applyFilters();
    });

    // Accordion: one group open at a time
    form.addEventListener('toggle', function (e) {
      var details = e.target;
      if (!details || !details.matches('details.filter-group')) return;
      if (details.hasAttribute('open')) {
        closeAllGroups(details);
      }
    }, true);

    // Update price range display on change (no auto-apply)
    form.addEventListener('change', function (e) {
      var target = e.target;
      if (!target) return;
      if (target.classList && target.classList.contains('filter-price-range__input')) {
        updateRangeValue(target);
      }
    });

    // Apply Filters button: apply and close drawer
    form.addEventListener('click', function (e) {
      var applyBtn = e.target.closest('.collection-filters__apply');
      if (!applyBtn) return;
      e.preventDefault();
      closeDrawer();
      applyFilters();
    });

    // Initial setup
    setupFormContent();
  }

  // Export init function for infinite scroll
  window.CollectionJS.initializeProductCards = initializeProductCards;
  window.CollectionJS.swapSecondaryImages = swapSecondaryImages;

  // Swap secondary images to next colour's variant image
  function swapSecondaryImages() {
    document.querySelectorAll('.collection-product').forEach(function (card) {
      if (card.hasAttribute('data-secondary-swapped')) return;
      var sec = card.querySelector('.collection-product__image.is-secondary');
      if (!sec) return;
      var active = card.querySelector('.collection-product__swatch-button.is-active');
      var btns = card.querySelectorAll('.collection-product__swatch-button');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i] === active) continue;
        if (btns[i].classList.contains('is-disabled')) continue;
        var src = btns[i].getAttribute('data-variant-image');
        if (src) {
          sec.removeAttribute('srcset');
          sec.src = src;
          card.setAttribute('data-secondary-swapped', 'true');
          break;
        }
      }
    });
  }

  // Eagerly preload swatch images for above-the-fold cards
  function preloadVisibleCards() {
    var cards = document.querySelectorAll('.collection-product');
    for (var i = 0; i < cards.length; i++) {
      var rect = cards[i].getBoundingClientRect();
      // Stop once we hit a card below the viewport
      if (rect.top > window.innerHeight) break;
      preloadSwatchImages(cards[i]);
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    initializeProductCards();
    initializeFilters();
    swapSecondaryImages();
    requestAnimationFrame(function() {
      preloadVisibleCards();
    });
  });

  // Also swap after filter/infinite scroll updates
  document.addEventListener('collection:filtered', function() {
    setTimeout(swapSecondaryImages, 100);
  });

  // Re-initialize on back/forward navigation (bfcache restore)
  window.addEventListener('pageshow', function(event) {
    if (!event.persisted) return;
    // Card listeners are preserved by bfcache — only re-run filter setup
    initializeFilters();
  });
})();